import React from "react";
import Card from "../../components/Card";
import Table from "../../components/Table";
import EditClientModal from "./Components/EditClientModal";
import { entityListColumns, useEntityList } from "./TableData";
import "./index.scss";

const ClientList = () => {
    const {
        currentPage,
        setCurrentPage,
        isEditModalOpen,
        selectedClient,
        isLoading,
        handleEdit,
        handleSaveClient,
        handleCloseModal,
        handleDelete,
        totalPages,
        currentEntities,
        itemsPerPage,
        pagination,
    } = useEntityList();

    return (
        <div className="client-list-page">
            <div className="page-header">
                <h1 className="page-title">All Clients/Vendor</h1>
            </div>

            <Card>
                {isLoading ? (
                    <div className="loading-state">
                        <p>Loading entities...</p>
                    </div>
                ) : currentEntities.length === 0 ? (
                    <div className="empty-state">
                        <p>No entities found. Create your first entity to get started.</p>
                    </div>
                ) : (
                    <Table
                        columns={entityListColumns}
                        data={currentEntities}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        showPagination={true}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                        totalItems={pagination.totalItems}
                        itemsPerPage={itemsPerPage}
                        showPaginationInfo={true}
                    />
                )}
            </Card>

            <EditClientModal
                isOpen={isEditModalOpen}
                onClose={handleCloseModal}
                clientData={selectedClient}
                onSave={handleSaveClient}
            />
        </div>
    );
};

export default ClientList;